import { HttpErrorResponse } from "@angular/common/http";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { Upload } from "app/core/models/upload.model";
import { FileUploadComponent } from "app/shared/components/file-upload/file-upload.component";
import { ImportNavComponent } from "app/shared/components/import-nav/import-nav.component";
import { isEmpty } from "lodash-es";
import { DrugGroupAkaImportsService } from '../../../core/services/drug-group-aka-imports.service';

@Component({
    selector: 'app-capture-admin-import-drug-group-akas',
    templateUrl: './capture-admin-import-drug-group-akas.component.html',
    imports: [
        ImportNavComponent,
        FileUploadComponent,
        FaIconComponent
    ]
})
export class CaptureAdminImportDrugGroupAkasComponent {

  private drugGroupAkaImportsService = inject(DrugGroupAkaImportsService);
  private router = inject(Router);

  uploading = false;
  errors: string[] = [];

  onUploadStart() {
    this.uploading = true;
    this.errors = [];
  }

  onUploadCancel() {
    this.uploading = false;
  }

  onUploadComplete(upload: Upload) {
    this.drugGroupAkaImportsService.create(upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/tools/import-drug-group-akas/history']);
        this.uploading = false;
      },
      (error: HttpErrorResponse) => {
        this.uploading = false;
        this.errors = error.error.errors;
      }
    );
  }

  onUploadError() {
    this.uploading = false;
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
